export const TEACHER_LOGIN_ON_STUDENT_PAGE = 'error.staff.login.with.student.context';

const signInFormErrorMap: Record<string, string> = {
  [TEACHER_LOGIN_ON_STUDENT_PAGE]:
    'Looks like you tried to sign in with an educator email. You can sign in using the Sign In / Register option below.',
};

export default signInFormErrorMap;
